import { useApiClient } from "../../../../shared/customHooks";
import { useApplicationContext } from "../../context/applicationContext";
import { childFormLegacy } from "../../../../shared/formObjects/application/legacy/childFormLegacy";
import BaseApplicationComponent from "../../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function ChildComponentLegacy({ disabled, data }: any) {
  const api = useApiClient("ChildLegacy");
  const { id } = useApplicationContext();

  return (
    <BaseApplicationComponent
      formBody={childFormLegacy}
      headerLabel="Child Details"
      editPath="child"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
    />
  );
}

export default ChildComponentLegacy;
